import React from 'react';
import { Button, Form } from 'react-bootstrap';
import { Field, reduxForm, formValueSelector } from 'redux-form';
import { AutoComplete, Checkbox, TextField } from "../common/FormComponents";
import { FormControlLabel, MenuItem } from '@material-ui/core';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSpinner } from '@fortawesome/free-solid-svg-icons';
import { toArray } from "../common/util";
import { Row } from 'react-bootstrap';
import { connect } from 'react-redux';

const validate = values => {
    const errors = {};

    if (!values.title) {
        errors.title = '* Required'
    }
    if (!values.section) {
        errors.section = '* Required';
    }
    if (!values.location) {
        errors.location = '* Required';
    }
    if (!values.dkp) {
        errors.dkp = '* Required';
    }

    return errors;
};



export const onlyDecimal = value => {
    value = value
        .replace(/[^0-9.]/g, '') // Remove all chars except numbers and .

    // Create an array with sections split by .
    const sections = value.split('.')

    // Remove any leading 0s apart from single 0
    if (sections[0] !== '0' && sections[0] !== '00') {
        sections[0] = sections[0].replace(/^0+/, '')
    } else {
        sections[0] = '0'
    }

    // If numbers exist after first .
    if (sections[1]) {
        // Join first two sections and truncate end section to length 2
        return sections[0] + '.' + sections[1].slice(0, 2)
        // If original value had a decimal place at the end, add it back
    } else if (value.indexOf('.') !== -1) {
        return sections[0] + '.'
        // Otherwise, return only section
    } else {
        return sections[0]
    }
};




const EventsForm = props => {
    const { handleSubmit, sectionValue, locationValue } = props;
    const onKeyPress = (event) => {
        if (event.key === 'Enter') {
            event.preventDefault();
        }
    };

    const [formState, setFormState] = React.useState({
        location: []
    });

    const handleFieldChange = event => {
        console.log(event);
        event.persist();
        setFormState(formState => ({
            ...formState,
            [event.target.name]:
                event.target.type === "checkbox"
                    ? event.target.checked
                    : event.target.value
        }));

    };

    return (
        <Form onSubmit={handleSubmit}>

            <div className="panel-adt">
                <Row>
                    <Field component={TextField}
                        name="title"
                        type="text"
                        label="Event Title"
                        onChange={this.handleChange}
                        helperText={<span />}
                    />
                </Row>
                <Row>
                    <Field component={TextField}
                        name="section"
                        select
                        label="Event DKP Section"
                        fullWidth
                        helperText={<span></span>}
                        onChange={event => {
                            props.getMembers(props.sections[event.target.value].chapter)
                        }}
                    >
                        {toArray(props.sections)
                            .sort((a, b) => (b.id - a.id)).map((section) => (
                                <MenuItem key={section.id} value={section.id}>{section.title}</MenuItem>
                            ))}
                    </Field>
                </Row>

                <Row>
                    <Field component={TextField}
                        name="location"
                        select
                        label="Event Location"
                        fullWidth
                        helperText={<span></span>}

                        SelectProps={{
                            multiple: true,
                            value: formState.location,
                            onChange: handleFieldChange
                        }}
                    >
                        {props.sectionValue && toArray(props.locations)
                            .filter((location) => location.game === props.chapters[props.sections[sectionValue].chapter].game.id)
                            .sort((a, b) => (b.id - a.id)).map((location) => (
                                <MenuItem key={location.id} value={location.id}>{location.title}</MenuItem>
                            ))}
                    </Field>
                </Row>

                <Row>
                    <Field component={AutoComplete}
                        name="eventLeader"
                        type="text"
                        label="Event Leader"
                        completeField="displayName"
                        suggestions={toArray(props.users)}
                        helperText={<span />}
                    />
                </Row>

                <Row>
                    <Field component={TextField}
                        name="dkp"
                        type="text"
                        label="DKP Per Hour"
                        onChange={this.handleChange}
                        normalize={onlyDecimal}
                        helperText={<span />}
                        default={0}
                    />
                    <span> </span>
                    <Field component={TextField}
                        name="standbyRate"
                        type="text"
                        label="Standby Multiplier"
                        onChange={this.handleChange}
                        normalize={onlyDecimal}
                        helperText={<span>A value of 1 will give DKP at an equal rate to players on standby.</span>}
                    />
                </Row>
                <Row>
                    <FormControlLabel control={<Field name="standbyEntities" component={Checkbox} onChange={this.handleChange} onKeyPress={onKeyPress} />} label="Standby awarded kills" />
                    <FormControlLabel control={<Field name="scheduled" component={Checkbox} onChange={this.handleChange} onKeyPress={onKeyPress} />} label="Scheduled in advance" />
                </Row>
                <Row>
                    <Field component={TextField}
                        name="copy"
                        select
                        label="Copy Attendance From Event"
                        fullWidth
                        helperText={<span></span>}
                    >
                        {toArray(props.events.data)
                            .sort((a, b) => (b.id - a.id)).map((event) => (
                                <MenuItem key={event.id} value={event.id}>{event.title}</MenuItem>
                            ))}
                    </Field>
                </Row>
                <Row>
                    <Button type="submit" disabled={props.pristine || props.pending}>
                        {(props.pending) ? (
                            <FontAwesomeIcon className="text-primary" icon={faSpinner} spin fixedWidth />
                        ) : ('')}
                        Create New Event
                    </Button>
                </Row>
            </div>

        </Form>
    )
};
const selector = formValueSelector('eventsForm');

export default connect(
    state => {
        const sectionValue = selector(state, 'section');
        return { sectionValue }
    }
)(reduxForm({ form: 'eventsForm', validate, })(EventsForm))


// WEBPACK FOOTER //
// ./src/Officer/EventsForm.js